/** Icons are imported separatly to reduce build time */
import BellIcon from "@heroicons/react/24/outline/BellIcon";
import DocumentTextIcon from "@heroicons/react/24/outline/DocumentTextIcon";
import Squares2X2Icon from "@heroicons/react/24/outline/Squares2X2Icon";
import TableCellsIcon from "@heroicons/react/24/outline/TableCellsIcon";
import WalletIcon from "@heroicons/react/24/outline/WalletIcon";
import CodeBracketSquareIcon from "@heroicons/react/24/outline/CodeBracketSquareIcon";
import DocumentIcon from "@heroicons/react/24/outline/DocumentIcon";
import ExclamationTriangleIcon from "@heroicons/react/24/outline/ExclamationTriangleIcon";
import CalendarDaysIcon from "@heroicons/react/24/outline/CalendarDaysIcon";
import ArrowRightOnRectangleIcon from "@heroicons/react/24/outline/ArrowRightOnRectangleIcon";
import UserIcon from "@heroicons/react/24/outline/UserIcon";
import Cog6ToothIcon from "@heroicons/react/24/outline/Cog6ToothIcon";
import BoltIcon from "@heroicons/react/24/outline/BoltIcon";
import ChartBarIcon from "@heroicons/react/24/outline/ChartBarIcon";
import CurrencyDollarIcon from "@heroicons/react/24/outline/CurrencyDollarIcon";
import InboxArrowDownIcon from "@heroicons/react/24/outline/InboxArrowDownIcon";
import UsersIcon from "@heroicons/react/24/outline/UsersIcon";
import KeyIcon from "@heroicons/react/24/outline/KeyIcon";
import DocumentDuplicateIcon from "@heroicons/react/24/outline/DocumentDuplicateIcon";
import WrenchScrewdriverIcon from "@heroicons/react/24/outline/WrenchScrewdriverIcon";

const iconClasses = `h-6 w-6`;
const submenuIconClasses = `h-5 w-5`;

const routes = [
  {
    path: "/admin/messages", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Messages - Sunday Meetings", // name that appear in Sidebar
  },
  {
    path: "/admin/special-messages", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Messages - Special Meetings", // name that appear in Sidebar
  },
  {
    path: "/admin/special-meetings", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Special Meetings", // name that appear in Sidebar
  },
    {
    path: "/admin/bulletins", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Bulletins", // name that appear in Sidebar
  },
  {
    path: "/admin/schedules", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Schedules", // name that appear in Sidebar
  },
  {
    path: "/admin/services-assignment", //no url needed as this has submenu
    icon: <InboxArrowDownIcon className={`${iconClasses} inline`} />, // icon component
    name: "Service Assignment", // name that appear in Sidebar
    submenu: [
      {
        path: "/admin/services-assignment/message",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Message",
      },
      {
        path: "/admin/services-assignment/breaking-bread",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Breaking Bread",
      },
      {
        path: "/admin/services-assignment/sunday-school",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Sunday School",
      },
      {
        path: "/admin/services-assignment/weekly-duties",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Weekly Duties",
      },
      {
        path: "/admin/services-assignment/bible-study",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Bible Study",
      },
    ],
  },
  {
    path: "/admin/services-metadata", //no url needed as this has submenu
    icon: <InboxArrowDownIcon className={`${iconClasses} inline`} />, // icon component
    name: "Service Metadata", // name that appear in Sidebar
    submenu: [
      {
        path: "/admin/services-metadata/message",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Message",
      },
      {
        path: "/admin/services-metadata/breaking-bread",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Breaking Bread",
      },
      {
        path: "/admin/services-metadata/sunday-school",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Sunday School",
      },
      {
        path: "/admin/services-metadata/weekly-duties",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Weekly Duties",
      },
      {
        path: "/admin/services-metadata/bible-study",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Bible Study",
      },
    ],
  },
  {
    path: "", //no url needed as this has submenu
    icon: <WrenchScrewdriverIcon className={`${iconClasses} inline`} />, // icon component
    name: "Development", // name that appear in Sidebar
    submenu: [
      {
        path: "/admin/development/dashboard",
        icon: <Squares2X2Icon className={submenuIconClasses} />,
        name: "Dashboard",
      },
      {
        path: "/admin/development/leads",
        icon: <InboxArrowDownIcon className={submenuIconClasses} />,
        name: "Leads",
      },
      {
        path: "/admin/development/transactions",
        icon: <CurrencyDollarIcon className={submenuIconClasses} />,
        name: "Transactions",
      },
      {
        path: "/admin/development/charts",
        icon: <ChartBarIcon className={submenuIconClasses} />,
        name: "Analytics",
      },
      {
        path: "/admin/development/integration",
        icon: <BoltIcon className={submenuIconClasses} />,
        name: "Integration",
      },
      {
        path: "/admin/development/calendar",
        icon: <CalendarDaysIcon className={submenuIconClasses} />,
        name: "Calendar",
      },
      {
        path: "/admin/development/blank",
        icon: <DocumentIcon className={submenuIconClasses} />,
        name: "Blank Page",
      },
      {
        path: "/admin/development/404",
        icon: <ExclamationTriangleIcon className={submenuIconClasses} />,
        name: "404",
      },
      {
        path: "/admin/development/settings-profile",
        icon: <UserIcon className={submenuIconClasses} />,
        name: "Profile Settings",
      },
      {
        path: "/admin/development/settings-billing",
        icon: <WalletIcon className={submenuIconClasses} />,
        name: "Billing",
      },
      {
        path: "/admin/development/settings-team",
        icon: <UsersIcon className={submenuIconClasses} />,
        name: "Team Members",
      },
      {
        path: "/admin/development/getting-started",
        icon: <DocumentTextIcon className={submenuIconClasses} />,
        name: "Getting Started",
      },
      {
        path: "/admin/development/features",
        icon: <TableCellsIcon className={submenuIconClasses} />,
        name: "Features",
      },
      {
        path: "/admin/development/components",
        icon: <CodeBracketSquareIcon className={submenuIconClasses} />,
        name: "Components",
      },
    ],
  },
];

export default routes;
